<section class="auth-wrapper auth-v1 px-2">
  <div [formGroup]="newUser" class="auth-inner py-2 form-custom-style">
    <div
      [ngClass]="{
        active:
          currentScreen.user.active &&
          (!currentScreen.user.onEnter || currentScreen.user.onEnter)
      }"
      class="user-card card mb-0"
    >
      <div class="card-body">
        <a class="brand-logo">
          <img
            src="../../../../../assets/images/pages/logo_white.png"
            alt="brand-logo"
            height="80"
          />
        </a>

        <h4 class="card-title mb-1">Finish setting up your account!</h4>
        <p class="card-text mb-2">
          We're not done yet, some few more steps and we will be done.
        </p>

        <form formGroupName="user" class="auth-login-form mt-2">
          <div class="form-group image-fg">
            <img
              [src]="imageObject.profile_photo"
              alt="profile_photo"
              class="profile_image"
            />
            <input
              hidden
              (change)="fileHandler($event, 'profile_photo')"
              type="file"
              name="profile_photo"
              id="profile_photo"
              accept="image/*"
            />
            <label
              for="profile_photo"
              name="profile_photo"
              class="btn btn-primary"
            >
              <i class="feather icon-plus"></i>
              <span> Add profile image </span>
            </label>
          </div>

          <div class="form-group">
            <label for="address" class="form-label">Address</label>
            <input
              type="text"
              formControlName="address"
              class="form-control"
              placeholder="Ex: Cameroon - South west - Buea"
              aria-describedby="address"
              autocomplete="false"
              tabindex="1"
              id="address"
              [ngClass]="{
                'is-invalid':
                  getFormControl('user', 'address')?.invalid &&
                  getFormControl('user', 'address')?.dirty
              }"
            />
            <div
              *ngIf="
                getFormControl('user', 'address')?.invalid &&
                getFormControl('user', 'address')?.dirty
              "
              class="invalid-feedback"
            >
              <small> Address format is ( Country - Region - City ) </small>
            </div>
          </div>

          <div class="form-group">
            <label for="user-phone-number" class="form-label"
              >Phone number</label
            >
            <input
              type="text"
              formControlName="phone_number"
              class="form-control"
              placeholder="Ex: +237678263988"
              aria-describedby="user-phone-number"
              autocomplete="false"
              tabindex="1"
              id="user-phone-number"
              [ngClass]="{
                'is-invalid':
                  getFormControl('user', 'phone_number')?.invalid &&
                  getFormControl('user', 'phone_number')?.dirty
              }"
            />
            <div
              *ngIf="
                getFormControl('user', 'phone_number')?.invalid &&
                getFormControl('user', 'phone_number')?.dirty
              "
              class="invalid-feedback"
            >
              <small> Phone number is invalid </small>
            </div>
          </div>

          <button
            type="submit"
            class="btn btn-primary btn-block"
            tabindex="4"
            rippleEffect
            (click)="toggleScreens('user')"
          >
            Next
            <i data-feather="arrow-right"></i>
          </button>
        </form>

        <p class="text-center mt-2">
          <small>Your information are secured</small>
        </p>
      </div>
    </div>

    <div
      [ngClass]="{
        active: currentScreen.school.active && currentScreen.school.onEnter
      }"
      class="school-card card mb-0"
    >
      <div class="card-body">
        <a class="brand-logo">
          <img
            src="../../../../../assets/images/pages/logo_white.png"
            alt="brand-logo"
            height="80"
          />
        </a>

        <h4 class="card-title mb-1">Finish setting up your school!</h4>
        <p class="card-text mb-2">
          Final step in setting up you institution. Few more steps and we are
          done
        </p>

        <form formGroupName="school" class="auth-login-form mt-2">
          <div class="form-group image-fg">
            <img [src]="imageObject.logo" alt="logo" class="profile_image" />
            <input
              hidden
              (change)="fileHandler($event, 'logo')"
              type="file"
              name="logo"
              id="logo"
              accept="image/*"
            />
            <label for="logo" name="logo" class="btn btn-primary">
              <i class="feather icon-plus"></i>
              <span> Add school logo </span>
            </label>
          </div>

          <div class="form-group">
            <label for="school-address" class="form-label">Address</label>
            <input
              type="text"
              formControlName="address"
              class="form-control"
              placeholder="Ex: Cameroon - South west - Buea"
              aria-describedby="school-address"
              autocomplete="false"
              tabindex="1"
              id="school-address"
              [ngClass]="{
                'is-invalid':
                  getFormControl('school', 'address')?.invalid &&
                  getFormControl('school', 'address')?.dirty
              }"
            />
            <div
              *ngIf="
                getFormControl('school', 'address')?.invalid &&
                getFormControl('school', 'address')?.dirty
              "
              class="invalid-feedback"
            >
              <small> Address format is ( Country - Region - City ) </small>
            </div>
          </div>

          <div class="form-group">
            <label for="school-phone-number" class="form-label"
              >Phone number</label
            >
            <input
              type="text"
              formControlName="phone_number"
              class="form-control"
              placeholder="Ex: +237678263988"
              aria-describedby="school-phone-number"
              autocomplete="false"
              tabindex="1"
              id="school-phone-number"
              [ngClass]="{
                'is-invalid':
                  getFormControl('school', 'phone_number')?.invalid &&
                  getFormControl('school', 'phone_number')?.dirty
              }"
            />
            <div
              *ngIf="
                getFormControl('school', 'phone_number')?.invalid &&
                getFormControl('school', 'phone_number')?.dirty
              "
              class="invalid-feedback"
            >
              <small> Phone number is invalid </small>
            </div>
          </div>

          <button
            type="submit"
            class="btn btn-primary btn-block"
            tabindex="4"
            (click)="createAccount()"
            rippleEffect
          >
            Submit
            <i data-feather="send"></i>
          </button>
        </form>

        <a (click)="toggleScreens('school')" class="text-center mt-2 back-btn">
          <i data-feather="arrow-left"></i>
          <span>&nbsp;Back</span>
        </a>
      </div>
    </div>
  </div>
</section>
